export default __webpack_public_path__ + "static/media/icon-check.adf7be72.svg";